import plaidMark from "@/assets/images/plaid-mark.svg";
import stripeMark from "@/assets/images/stripe-mark.svg";
import classNames from "classnames";
import type { BankConnectionProvider } from "../bankConnectionProvider";
import { bankConnectionProviderLabel } from "../bankConnectionProvider";

interface BankConnectionProviderIconProps {
  provider: BankConnectionProvider;
  size?: number;
  showLabel?: boolean;
  className?: string;
}

function PlaidIcon({ size }: { size: number }) {
  return <img src={plaidMark} width={size} height={size} alt="" aria-hidden="true" className="flex-shrink-0" />;
}

function StripeFinancialConnectionsIcon({ size }: { size: number }) {
  return <img src={stripeMark} width={size} height={size} alt="" aria-hidden="true" className="flex-shrink-0" />;
}

export default function BankConnectionProviderIcon({
  provider,
  size = 20,
  showLabel = false,
  className
}: BankConnectionProviderIconProps) {
  if (provider === "MANUAL") return null;

  const label = bankConnectionProviderLabel(provider);
  const icon = provider === "PLAID" ? <PlaidIcon size={size} /> : <StripeFinancialConnectionsIcon size={size} />;

  return (
    <span
      className={classNames("inline-flex items-center gap-1.5", className)}
      data-testid={`bank-connection-provider-${provider.toLowerCase()}`}
      aria-label={label ?? undefined}
      title={label ?? undefined}
    >
      {icon}
      {showLabel && label && <span className="text-body-medium text-sys-brand-on-surface">{label}</span>}
    </span>
  );
}
